<template>
    <div id="transactionCompletePage">
        <div class="d-flex flex-column rounded align-items-center text-center py-4 px-lg-5 px-3 bg-white">
            <div class="lazada-hc-logo"></div>
            <div class="d-flex flex-column align-items-center text-center p-2">
                <img alt="" src="/img/lazada/install-app-icon.png" class="img-responsive">
                <span class="font-md font-weight-bold my-3">
                    It's nice that you already have the <br />Home Credit app!
                </span>
                <span class="font-sm text-secondary">
                    You need an HomeCredit Account to top up your Lazada Wallet, but don't worry! We have a lot of features and products that can help you.
                </span>
            </div>
        </div>
        <div class="d-flex flex-column rounded align-items-center text-center py-4 px-lg-5 px-3 mt-2 bg-white">
            <span class="font-sm text-secondary mt-3 mb-5">
                Manage payments, avail of loans, shop in installments, receive promos and many more with Home Credit app!
                <br />
                <br />
                To learn more about HCPay, visit our website
            </span>
            <lazada-return>Back to Lazada</lazada-return>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import embed_video from '../../components/embed_video.vue';
export default {
  components: { embed_video },
    created() {},
    
}
</script>
<style scoped>
    .transactionCompleteIcon {
        height: auto;
        width: 7rem;
    }
    .lazada-hc-logo {
        /* Layout Properties */
        top: 14px;
        left: 36px;
        width: 100%;
        height: 52px;
        margin-bottom: 41px;
        /* UI Properties */
        background: transparent url('/img/lazada/logos_desktop.png') center no-repeat padding-box;
        opacity: 1;
    }
    .cancel-margin-bottom {
        margin-bottom: 45px;
    }
    .download-margin-bottom {
        margin-bottom: 32px;
    }
</style>